import { apiClient } from './client';

export interface PayrollPeriodSummary {
  periodId:    string;
  label:       string;
  startDate:   string;
  endDate:     string;
  status:      'OPEN' | 'CLOSED';
  costBasis:   'TOTAL_PRODUCTION' | 'SELLABLE_PRODUCTION';
  totalAmount: number;
  createdAt:   string;
  closedAt?:   string;
}

export interface PayrollEntry {
  entryId:     string;
  periodId:    string;
  tenantId:    string;
  loteId:      string;
  batchId?:    string;
  workerName:  string;
  workerPhone?: string;
  payType:     'JORNAL' | 'DESTAJO' | 'CONTRATO';
  activity:    string;
  days?:       number;
  units?:      number;
  unitLabel?:  string;
  rate:        number;
  totalPay:    number;
  recordedBy:  string;
  createdAt:   string;
  notes?:      string;
}

export interface PayrollSummaryResponse {
  periods:     PayrollPeriodSummary[];
  openPeriod?: PayrollPeriodSummary;
  entries:     PayrollEntry[];
  totalAmount: number;
  byPayType: {
    JORNAL:   number;
    DESTAJO:  number;
    CONTRATO: number;
  };
  byLote: Array<{ loteId: string; amount: number }>;
  workerCount: number;
}

/** Lista períodos de nómina (más recientes primero) */
export const fetchPayrollPeriods = async (): Promise<PayrollPeriodSummary[]> =>
  (await apiClient.get('/api/payroll/periods')).data;

/** Período abierto actual + entries */
export const fetchPayrollSummary = async (ranchoId?: string | null): Promise<PayrollSummaryResponse> =>
  (await apiClient.get('/api/payroll/summary', { params: ranchoId ? { ranchoId } : undefined })).data;

/** Entries de un período específico */
export const fetchPayrollEntries = async (periodId: string): Promise<PayrollEntry[]> =>
  (await apiClient.get(`/api/payroll/periods/${periodId}/entries`)).data;

// ── Mutaciones (dashboard) ────────────────────────────────────────────────────

export interface OpenPayrollPeriodInput {
  startDate:  string;
  endDate:    string;
  label:      string;
  costBasis?: 'TOTAL_PRODUCTION' | 'SELLABLE_PRODUCTION';
  notes?:     string;
}

export const openPayrollPeriod = async (input: OpenPayrollPeriodInput): Promise<PayrollPeriodSummary> =>
  (await apiClient.post('/api/payroll/periods', input)).data;

export const closePayrollPeriod = async (periodId: string, notes?: string): Promise<PayrollPeriodSummary> =>
  (await apiClient.post(`/api/payroll/periods/${periodId}/close`, { notes })).data;

export interface AddPayrollEntryInput {
  loteId:       string;
  batchId?:     string;
  workerName:   string;
  workerPhone?: string;
  payType:      'JORNAL' | 'DESTAJO' | 'CONTRATO';
  activity:     string;
  days?:        number;
  units?:       number;
  unitLabel?:   string;
  rate:         number;
  notes?:       string;
}

export const addPayrollEntry = async (periodId: string, input: AddPayrollEntryInput): Promise<PayrollEntry> =>
  (await apiClient.post(`/api/payroll/periods/${periodId}/entries`, input)).data;
